import Keycloak from "keycloak-js";
const keycloakConfig = {
  url: window.UepAppData.AUTH_ENDPOINT,
  realm: window.UepAppData.REALM,
  clientId: window.UepAppData.CLIENT_ID,
  onLoad: "login-required",
  "ssl-required": "external",
  resource: "webapp",
  "public-client": true,
  "confidential-port": 0,
};
const keycloak = new Keycloak(keycloakConfig);
export default keycloak;
